import React, { useEffect } from 'react'
import { TabEl, TabHeadersEl } from '../elements'
import { tabs } from '../config'
import { H5 } from '../../../../../../../../../../Styles/typography'
import RecordedCourseDashboardStore from '../../../../../stores/RecordedCourseDashboardStore'
import { spring } from '../../../config/animation'
import { withRouter } from 'react-router-dom'

const Headers = ({
  match: {
    params: { livDemyID, courseURL, tab },
  },
  history,
}) => {
  const {
    expanded,
    active,
    setActive,
  } = RecordedCourseDashboardStore.useContainer()

  useEffect(() => {
    const activeTab = tabs.findIndex(({ route }) => route === tab)

    if (activeTab === -1) {
      history.push(`/${livDemyID}/course/${courseURL}/${tabs[0].route}`)
    } else {
      setActive(activeTab)
    }
  }, [courseURL, history, livDemyID, setActive, tab])

  return (
    <TabHeadersEl expanded={expanded} layout transition={spring}>
      {tabs.map(({ name, route }, index) => (
        <TabEl
          key={`tab-${index}`}
          active={active === index}
          onClick={() =>
            history.push(`/${livDemyID}/course/${courseURL}/${route}`)
          }
        >
          <H5>{name}</H5>
        </TabEl>
      ))}
    </TabHeadersEl>
  )
}

export default withRouter(Headers)
